module.exports = __webpack_public_path__ + "school/img/enModelCourseDetail.9c302398.jpg";